import api from 'config/api/protectedApi';
import { apiRoutes } from 'config/api/apiRoutes';
import useError from 'utils/useError';
import { INumberFormData, IWhatsAppNumber, PHONE_STATUS } from 'models/whatsAppNumberModel';

export const useWhatsAppNumberApi = () => {

    const { throwException } = useError()

    async function getWhatsAppNumberList(): Promise<IWhatsAppNumber[]> {
        return api.get(apiRoutes.getWhatsAppNumbers)
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function getWhatsAppNumberListByStatusIds(statusIds : Array<number>): Promise<IWhatsAppNumber[]> {
        return api.get(apiRoutes.getWhatsAppNumbersByStatusIds, {
            params: {
                statusIds: statusIds.join(',')
            }
        })
            .then(response => response.data)
            .catch(error => {
                throw error
            });
    }

    async function createWhatsAppNumber(whatsAppNumber: INumberFormData): Promise<string> {
        const data = {
            countryCode: whatsAppNumber.countryCode,
            phoneNumber: whatsAppNumber.phoneNumber,
            displayName: whatsAppNumber.displayName,
        }
        return api.post(apiRoutes.createWhatsAppNumber, data)
            .then((response) => {
                const numberId = response.data as string
                return numberId
            })
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function verifyWhatsAppNumber(phoneNumberId: string, verificationCode: string): Promise<string> {
        const data = {
            phoneNumberId: phoneNumberId,
            verificationCode: verificationCode
        }
        return api.post(apiRoutes.verifyWhatsAppNumber, data)
            .then((response) => {
                const numberId = response.data as string
                return numberId
            })
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function requestWhatsAppNumberVerificationCode(phoneNumberId: string): Promise<boolean> {
        const data = {
            phoneNumberId: phoneNumberId
        }
        return api.post(apiRoutes.requestWhatsAppNumberVerificationCode, data)
            .then(() => true)
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    async function syncNumbers(): Promise<boolean> {
        return api.get(apiRoutes.syncNumbers)
            .then(() => true)
            .catch(error => {
                throwException(error)
                throw error
            });
    }

    return {
        getWhatsAppNumberList, getWhatsAppNumberListByStatusIds,
        createWhatsAppNumber, verifyWhatsAppNumber,
        requestWhatsAppNumberVerificationCode, syncNumbers
    }
}